//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

// The display name for a fully qualified frame name: the query response's
// display_name_map when it has one, otherwise the name with its namespace
// prefix (everything before '__') stripped. Here rather than beside the graph
// code so the app shell can strip a name without loading the graph chunk.
export function getDisplayName(
  fqName: string,
  displayNameMap?: Record<string, string>
): string {
  if (!fqName)
    return fqName;
  if (displayNameMap && fqName in displayNameMap)
    return displayNameMap[fqName];
  const parts = fqName.split('__');
  return parts.length > 1 ? parts.slice(1).join('__') : fqName;
}
